export default "__VITE_ASSET__jU$aWITS__"